import React from "react";
import EntryPageData from "../assets/json/entrypages.json";
import DataTable from "./DataTable";


const EntryPage = () => {
    const columns = [
        { headname: "PAGE URL", dbcol: "col1", type: "text" },
        { headname: "PAGE VIEWS", dbcol: "col2", type: "time" },
        { headname: "AVG. SESSION DURATION", dbcol: "col3", type: "text" },
        { headname: "BOUNCE RATE(%)", dbcol: "col4", type: "text" },
    ];


    return (
        <div style={{
            background: "#fff",
            padding: "24px",
            marginTop: "20px",
        }}>
            <h3 style={{ marginBottom: "20px", color: "#1A1F36", fontWeight: "600" }}>
                Top Entry Pages
            </h3>

            <DataTable
                id="EntryPageData"
                columns={columns}
                data={EntryPageData}
            />
        </div>
    );
}
export default EntryPage;